export default "__VITE_ASSET__4dYgIscb__"